<script>
  export let i;
  export let classList = "";
</script>

<style>
  span.fas.mid {
    color: #888;
  }
  span.fas.light {
    color: #ccc;
  }
</style>
<span class="fas fa-{i} {classList}"></span>